window.addEventListener('DOMContentLoaded', () => {
    const checkBundlePromoTiles = () => {
        const currencyRate = Shopify.currency.rate;
        const currencyCode = Shopify.currency.active;

        const bundlePromoTiles = document.querySelectorAll('.bundle-promo-tile');
        for (let i = 0; i < bundlePromoTiles.length; i++) {
            const priceFields = bundlePromoTiles[i].querySelectorAll('span[data-price]');
            priceFields.forEach(priceField => {
                const basePrice = +priceField.getAttribute('data-price')
                const calculatedPrice = basePrice * currencyRate
                const dollar_val = Math.round(calculatedPrice / 100.0)
                calculatedPrice_round = dollar_val * 100
                const formattedPrice = FoxTheme.Currency.formatMoney(calculatedPrice_round, FoxTheme.settings.moneyFormat)
                
                priceField.innerHTML = `${formattedPrice}`;
            })
        }
    }
    checkBundlePromoTiles();
})

window.addEventListener('load', () => {
    const maxReloadAttempts = 3;
    const reloadStorageKey = 'unicornReloadAttempts';

    if (Shopify.designMode || window.unicornActiveGlobal === true) {
        sessionStorage.removeItem(reloadStorageKey);
        return;
    }

    // Persist attempts site-wide so a failed third-party app cannot cause an infinite reload loop across pages.
    const reloadAttempts = Number(sessionStorage.getItem(reloadStorageKey) || 0);

    if (reloadAttempts < maxReloadAttempts) {
        sessionStorage.setItem(reloadStorageKey, String(reloadAttempts + 1));
        window.location.reload();
    }
})
